<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="サービスのキャンセル"
        @hidden="close">
        <div
            v-if="isLoadedState"
            class="modal-body">
            <div class="card">
                <div class="card-header">提供中のサービス</div>
                <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <h5 class="subscriptionName">{{ plan.common_name }}</h5>
                            <div class="subscriptionPeriod">
                                <div>{{ `ご利用期間: ${periodStart} 〜 ${periodEnd}（日本時間）` }}</div>
                                <div v-if="isGroup">{{ `${$locale.patient}: ${user.full_name}` }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template v-if="!isAdmin">
                <div v-if="helper.isCyclePlan(plan)">
                    <ul class="text-muted mt-3 mb-3 pl-3">
                        <li v-if="isStatusNotStarted">本オプションのキャンセルは、本オプションの利用申込み時に入力された当該ご利用期間の開始日の前日まで無償で可能となり、開始日以降の返金は致しかねます。
                        </li>
                        <li v-if="!isStatusNotStarted">キャンセル後もご利用期間の満了までは引き続きご利用いただけます。</li>
                        <li v-if="!isStatusNotStarted">ご利用期間以降の{{ $locale.consultation_host }}予約はキャンセルされます。</li>
                    </ul>
                </div>
                <div v-else>
                    <ul class="text-muted mt-3 mb-3 pl-3">
                        <li>本オプションのキャンセルは、本オプションの利用申込み時に入力された当該ご利用期間の開始日の前日まで無償で可能となり、開始日以降のキャンセルは行えません。
                        </li>
                        <li v-if="isGroup">キャンセル後は「{{ `個人${$locale.patient}` }}」に移行します。引き続き{{ $locale.appName }}をご利用いただけますが、次回から{{ $locale.consultation_host }}ごとに料金が発生いたしますのでご注意ください（月額利用料等は必要ありません）。</li>
                        <li v-else>{{ $locale.appName }}運営側でキャンセルを確認次第、返金対応を行います。入金までに数週間かかる場合がございますので、予めご了承ください。</li>
                    </ul>
                </div>
            </template>
        </div>

        <div
            v-if="isLoadedState"
            slot="modal-footer">
            <div class="d-flex justify-content-end align-items-center">
                <button
                    class="btn btn-yokumiru-gray mr-2"
                    :disabled="inProgress"
                    @click="close">
                    閉じる
                </button>
                <button
                    class="btn btn-danger float-right"
                    :disabled="inProgress"
                    @click="handleOk">
                    キャンセルする
                </button>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import constants from '../../../constants'
    import YokumiruHelper from '../../../YokumiruHelper'
    import moment from "moment-timezone";

    export default {
        props: {
            isGroup: {
                type: Boolean,
                default: false,
            },
            isAdmin: {
                type: Boolean,
                default: false,
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                user: null,
                plan: null,
                subscription: null,
                modalShow: false,
                inProgress: false,
            }
        },

        computed: {
            isLoadedState: function () {
                return this.user !== null
                    && this.plan !== null
                    && this.subscription !== null
            },

            periodStart: function () {
              if (!this.isLoadedState) return ''

              if (this.helper.isCyclePlan(this.plan)) {
                return moment(this.subscription.current_period_start).format('YYYY年M月D日 HH:mm')
              }
              return moment(this.subscription.period_start).format('YYYY年M月D日')
            },

            periodEnd: function () {
              if (!this.isLoadedState) return ''

              if (this.helper.isCyclePlan(this.plan)) {
                return moment(this.subscription.current_period_end).format('YYYY年M月D日 HH:mm')
              }
              return moment(this.subscription.period_end).format('YYYY年M月D日')
            },

            isStatusNotStarted: function () {
                if (!this.isLoadedState) return false

                return this.helper.isStatusNotStarted(this.subscription)
            },
        },

        created: function () {
            bus.$on('open-modal-subscription-cancel', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-subscription-cancel')
        },

        methods: {
            /**
             * モーダルを表示
             *
             * @param {object} user
             * @param {object} plan
             * @param {object} subscription
             */
            open: function(user, plan, subscription) {
                this.user = user
                this.plan = plan
                this.subscription = subscription
                this.modalShow = true
            },

            /**
             * モーダルを閉じる
             */
            close: function() {
                this.modalShow = false
            },

            /**
             * サービスのキャンセル
             */
            handleOk: async function () {
                if (this.inProgress) return
                this.inProgress = true

                let endpoint = `${constants.user.subscriptions.endpoint.base}/cancel`

                if (this.isAdmin) {
                    endpoint = `${constants.admin.subscriptions.endpoint.base}/${this.subscription.id}/cancel`
                }
                else if (this.isGroup) {
                    endpoint = `${constants.user.groups.endpoint.base}/${this.subscription.group_id}/subscriptions/${this.subscription.id}/cancel`
                }

                await axios.put(endpoint)
                    .then(() => {
                        bus.$emit('alert-success', 'サービスをキャンセルしました。')
                        bus.$emit('subscription-canceled')
                        this.close()
                    })
                    .catch( ({response}) => {
                        if (response.data.hasOwnProperty('errors') &&
                            response.data.errors.hasOwnProperty('message')) {
                            bus.$emit('alert-danger', response.data.errors.message[0])
                        }
                        else {
                            bus.$emit('alert-danger', `サービスをキャンセルできません。${this.$locale.appName}サポートまでお問い合わせください。`)
                        }
                    } )

                this.inProgress = false
            },
        },
    }
</script>
